module.exports = __webpack_public_path__ + "media/images/expand-d431af4a0aea6596fca843143a28c3de.svg";